import { render, staticRenderFns } from "./newlyinmessage.vue?vue&type=template&id=afaab0ba&scoped=true"
import script from "./newlyinmessage.vue?vue&type=script&lang=js"
export * from "./newlyinmessage.vue?vue&type=script&lang=js"
import style0 from "./newlyinmessage.vue?vue&type=style&index=0&id=afaab0ba&prod&scoped=true&lang=css"
import style1 from "./newlyinmessage.vue?vue&type=style&index=1&id=afaab0ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afaab0ba",
  null
  
)

export default component.exports